export const TUTORIAL_STEP_IDS = [
  'marketplace-connection',
  'products',
  'inventory',
  'suppliers',
  'purchase-order',
] as const;

export type TutorialStepId = (typeof TUTORIAL_STEP_IDS)[number];
